import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API, authHeaders } from '../api/ticketsApi';

/** Ticket no from detail-page action links (?ticket=TK-…). */
export function usePrefillTicketNo() {
  const [searchParams] = useSearchParams();
  return searchParams.get('ticket') || searchParams.get('ticket_no') || '';
}

/**
 * If the prefilled ticket is missing from the dropdown list, fetch it and prepend
 * (when optional filter allows). Call after the list has loaded.
 */
export async function ensureTicketInList(ticketNo, setTickets, { filter } = {}) {
  if (!ticketNo) return null;
  try {
    const res = await axios.get(`${API}/${ticketNo}`, authHeaders());
    const t = res.data;
    if (!t?.ticket_no) return null;
    if (typeof filter === 'function' && !filter(t)) return t;
    setTickets((prev) => {
      if (prev.some((x) => x.ticket_no === t.ticket_no)) return prev;
      return [t, ...prev];
    });
    return t;
  } catch {
    return null;
  }
}
